import React from 'react'
import Slick from './Slick'

const Brand = () => {
  return (
    <>
    <Slick/>

    {/* <div className='container' style={{width:"100%" , marginBottom:"40px"}} >
    <h1 style={{fontSize:"40px"}}>Trending Brands</h1>
    <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:"20px",width:"80%" ,marginTop:"40px"}}>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
    </div>
 </div><div className='container' style={{width:"100%" , marginBottom:"40px"}} >
    <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:"20px",width:"80%" ,marginTop:"40px"}}>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
         <div className="card" style={{width: "13rem"}}>
          <img style={{height: "18rem"}}  src="https://bit.ly/dan-abramov" className="card-img-top" alt="..."/>
          <div className="card-body">
            <h2 className="card-title" style={{textAlign:"center"}}>Card title</h2>
          </div>
        </div>
    </div>
 </div> */}
 </>
  )
}

export default Brand
